const MACHINERY_DIRECTIVE_COMPLIANCE_STUDIO_PATHNAME_PATTERN =
  /^\/product-catalog\/[^/]+\/machinery-directive\/[^/]+(?:\/.*)?$/

export function isComplianceStudioPathname(pathname: string): boolean {
  return MACHINERY_DIRECTIVE_COMPLIANCE_STUDIO_PATHNAME_PATTERN.test(pathname)
}
